import { type FilterChipsModalTab } from '@capsicum/common';
import styled from 'styled-components';

type ModalFilterTabHeaderProps = {
	onTabChange: (selectedTab: string) => void;
	selectedTab: string;
	tabs: Array<FilterChipsModalTab>;
	testID?: string;
};

export const HeaderTabView = ({ onTabChange, selectedTab, tabs, testID }: ModalFilterTabHeaderProps) => {
	return (
		<S.TabViewWrapper>
			<S.TabsWrapper>
				{tabs.map(tab => (
					<S.TabButton
						$active={selectedTab === tab.name}
						data-testid={`${testID}-tabBar-${tab.name}`}
						key={tab.name}
						onClick={() => onTabChange(tab.name)}
					>
						<S.TabButtonText $active={selectedTab === tab.name}>{tab.label}</S.TabButtonText>
					</S.TabButton>
				))}
			</S.TabsWrapper>
		</S.TabViewWrapper>
	);
};

namespace S {
	export const TabViewWrapper = styled.div`
		background-color: ${({ theme }) => theme.colors.backgrounds.main.container};
	`;

	export const TabButton = styled.div<{
		$active: boolean;
	}>`
		width: 81px;
		display: flex;
		align-items: center;
		justify-content: center;
		border-bottom: solid ${({ theme }) => theme.border.width.large};
		border-bottom-color: ${({ $active, theme }) => ($active ? theme.colors.borders.brand.enabled : 'transparent')};
		cursor: pointer;
	`;

	export const TabsWrapper = styled.div`
		display: flex;
		flex-direction: row;
	`;

	export const TabButtonText = styled.p<{
		$active: boolean;
	}>`
		${({ theme }) => theme.fonts.text.text3};
		font-weight: ${({ $active }) => ($active ? 'bold' : 'normal')};
		color: ${({ theme }) => theme.colors.text.main.enabled};
	`;
}
